import { defineStore } from 'pinia';
import { StoreId } from '@/modules/common/enums/store-id.enum.ts';
import { PAGE_SIZE } from '@/modules/viewer/consts/request.const.ts';

interface State {
  instances: Record<string, number>;
}

export const useViewerStore = defineStore(StoreId.Viewer, {
  state: (): State => ({
    instances: {},
  }),
  getters: {
    getFirstPageLimit: (state) => (persistKey: string) => Math.max(state.instances[persistKey] ?? PAGE_SIZE, PAGE_SIZE),
    hasFirstPageLimit: (state) => (persistKey: string) => (state.instances[persistKey] ?? PAGE_SIZE) !== PAGE_SIZE,
  },
  actions: {
    setFirstPageLimit(persistKey: string, index: number) {
      this.instances[persistKey] = Math.ceil((index + 1) / PAGE_SIZE) * PAGE_SIZE;
    },
    resetFirstPageLimit(persistKey: string) {
      this.instances[persistKey] = PAGE_SIZE;
    },
  },
  persist: true,
});
